import { defaultData } from '../data/defaultData.js';

const STORAGE_KEY = 'xalo_media_hub_v1';

export const storage = {
  getStore() {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      if (data) {
        return JSON.parse(data);
      }
    } catch (e) {
      console.error('Failed to parse storage data', e);
    }
    // Seed with default data if empty
    this.saveStore(defaultData);
    return defaultData;
  },

  saveStore(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      window.dispatchEvent(new CustomEvent('storage-updated', { detail: data }));
    } catch (e) {
      console.error('Failed to save to localStorage', e);
    }
  },

  getSectionItems(section) {
    const store = this.getStore();
    return store[section] || [];
  },

  getAbout() {
    const store = this.getStore();
    const about = store.about || defaultData.about;
    if (about.persons && defaultData.about.persons) {
      about.persons.forEach((p, idx) => {
        if (p) {
          if (!p.banner) {
            p.banner = defaultData.about.persons[idx]?.banner || 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=800';
          }
          if (!p.social || !p.social.discord) {
            if (!p.social) p.social = {};
            p.social.discord = defaultData.about.persons[idx]?.social?.discord || 'https://discord.gg/xalonode';
          }
        }
      });
    }
    return about;
  },

  addItem(section, item) {
    const store = this.getStore();
    if (!store[section]) store[section] = [];
    
    // Auto-generate ID if not provided
    if (!item.id) {
      item.id = `${section[0]}_${Date.now()}`;
    }
    
    store[section].unshift(item);
    this.saveStore(store);
    return item;
  },

  updateItem(section, updatedItem) {
    const store = this.getStore();
    if (!store[section]) return false;
    
    const index = store[section].findIndex(i => i.id === updatedItem.id);
    if (index !== -1) {
      store[section][index] = { ...store[section][index], ...updatedItem };
      this.saveStore(store);
      return true;
    }
    return false;
  },

  deleteItem(section, id) {
    const store = this.getStore();
    if (!store[section]) return false;
    
    store[section] = store[section].filter(i => i.id !== id);
    this.saveStore(store);
    return true;
  },

  updatePerson(personId, personData) {
    const store = this.getStore();
    if (!store.about || !store.about.persons) return false;
    
    const index = store.about.persons.findIndex(p => p.id === personId);
    if (index !== -1) {
      store.about.persons[index] = { ...store.about.persons[index], ...personData };
      this.saveStore(store);
      return true;
    }
    return false;
  },

  updateAboutHeadings(title, subtitle) {
    const store = this.getStore();
    if (!store.about) store.about = { ...defaultData.about };
    store.about.title = title;
    store.about.subtitle = subtitle;
    this.saveStore(store);
    return true;
  },

  exportJSON() {
    const store = this.getStore();
    const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(store, null, 2));
    const downloadAnchor = document.createElement('a');
    downloadAnchor.setAttribute("href", dataStr);
    downloadAnchor.setAttribute("download", `xalo_media_backup_${new Date().toISOString().slice(0,10)}.json`);
    document.body.appendChild(downloadAnchor);
    downloadAnchor.click();
    downloadAnchor.remove();
  },

  importJSON(jsonString) {
    try {
      const parsed = JSON.parse(jsonString);
      if (parsed && parsed.books && parsed.films && parsed.games && parsed.apps && parsed.about) {
        this.saveStore(parsed);
        return { success: true };
      }
      return { success: false, message: "فایلی JSONەکە پێکهاتەی تەواوی نییە." };
    } catch (e) {
      return { success: false, message: "فایلی هەڵبژێردراو تێکچووە یان JSON نییە." };
    }
  },

  resetDefaults() {
    this.saveStore(defaultData);
  },

  getStats() {
    const store = this.getStore();
    return {
      books: (store.books || []).length,
      films: (store.films || []).length,
      games: (store.games || []).length,
      apps: (store.apps || []).length,
      persons: (store.about?.persons || []).length
    };
  }
};
